import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Grid } from "@material-ui/core"
import Header from "../../Header"
import { TitleSection, MetadataSection, ActionsView } from "../../bifrost"

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	table: {
		marginBottom: "80px",
	},
}))

const DetailsLayout = (props) => {
	const { titleProps, loading, actionItems, children, listView, showActionsView, leftActions, rightActions } = props
	const classes = useStyles()

	return (
		<Grid className={classes.root} container direction="row" data-testid="case_details_page">
			<Grid container>
				<TitleSection
					title={titleProps.title}
					name={titleProps.name}
					status={titleProps.status}
					isLoading={loading}
					actionItems={actionItems}
				/>
				<MetadataSection>{children}</MetadataSection>
				{showActionsView ? <ActionsView leftActions={leftActions} rightActions={rightActions}></ActionsView> : null}
				<Grid container item xs={12} className={classes.table}>
					{listView}
				</Grid>
			</Grid>
		</Grid>
	)
}

export default DetailsLayout
